module.exports = __webpack_public_path__ + "media/images/home/business-91794c8d91792f38626967ae82ffb21f.png";